var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 64,
    viewBox: "0 0 76 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 6.19034L70.4808 8.06836C59.578 12.3418 51.3282 19.6815 43.7563 28.3626C41.1225 31.3712 38.6825 34.5524 36.01 37.5227C33.7636 40.0331 31.2267 42.7927 28.012 44C27.7409 43.9617 26.9275 42.5436 26.7726 42.2561C24.1583 36.9095 26.2497 26.5229 21.3115 22.8435C20.3432 22.1152 19.1813 21.7128 18 21.4828C19.9559 18.4167 22.9963 16.8644 26.4434 18.8574C29.4451 20.6013 31.401 24.6065 31.827 27.941L31.9626 31.1029C35.3903 25.9863 39.612 21.3679 44.376 17.4393C53.0518 10.2913 64.4194 4.84889 76 6.2095V6.19034Z",
    fill: "url(#paint0_linear_122_9125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.802 8.05838C46.9788 8.97497 45.3898 10.579 44.4709 11.381C44.2986 11.5338 43.8009 11.9539 43.6478 12.0112C42.9969 12.2976 40.7188 11.6102 39.9147 11.381C35.7988 10.2735 32.0275 8.4212 28.1222 6.75987C23.432 9.03226 18.78 10.9991 13.6304 12.0494C11.5054 12.4886 9.15071 12.6222 7.08319 13.1187C6.91089 13.1569 6.48973 13.2524 6.37487 13.3479C5.83885 13.7298 6.26001 16.3077 6.27915 17.0142C6.45144 21.5972 6.47059 26.2375 7.50435 30.7058C9.61017 39.8145 14.0898 47.4337 21.307 53.4106C22.379 54.289 26.5524 57.3061 27.701 57.5353C28.8496 57.7644 31.5872 55.9121 32.621 55.1865C40.3742 49.8015 45.6579 41.9532 48.4337 32.9782L54.2343 27.1541L55 27.0204C54.598 30.8204 53.5259 34.7923 52.1667 38.3441C48.5868 47.5864 41.5611 55.7976 33.3676 61.2971C32.3529 61.9846 29.6537 63.7414 28.5625 63.9705C27.6819 64.1615 26.3418 63.3785 25.5569 62.9584C18.0908 58.872 10.7014 50.8327 6.66203 43.4045C1.32092 33.6084 0.325443 23.7168 0.0382864 12.7177C0.0191427 11.9348 -0.0765739 9.07045 0.134007 8.53577C0.229726 8.30662 0.593459 8.17295 0.823184 8.09657C10.5099 7.10359 19.5649 4.31562 28.2179 0C34.5736 2.90254 41.0059 5.76689 47.9742 6.87444C48.7017 7.12269 48.0508 7.69556 47.7637 8.03928L47.802 8.05838Z",
    fill: "url(#paint1_linear_122_9125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_9125",
    x1: 18,
    y1: 24.9898,
    x2: 76,
    y2: 24.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_9125",
    x1: 0.0382875,
    y1: 32.0234,
    x2: 55.0574,
    y2: 32.0234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.09b9e55fbc01e592c21d50d174f1de32.svg";
export { ForwardRef as ReactComponent };